import React from 'react'

const Icon404 = ({ className = '', size = '40' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={"256"}
      height={"120"}
      viewBox={`0 0 256 120`}
      fill="#71717A">
      <path opacity="0.4" d="M78.077 91.208H66.685V109H51.197V91.208H3.709V76.872L46.077 15.432H66.685V76.872H78.077V91.208ZM21.117 76.872H51.197V33.096L21.117 76.872ZM88.379 62.408C88.379 33.352 103.995 13.64 127.931 13.64C151.867 13.64 167.611 33.352 167.611 62.408C167.611 91.336 152.763 110.664 127.931 110.664C103.099 110.664 88.379 91.336 88.379 62.408ZM104.507 62.408C104.507 84.04 113.211 96.2 127.931 96.2C142.779 96.2 151.483 84.04 151.483 62.408C151.483 40.264 142.779 28.104 127.931 28.104C113.211 28.104 104.507 40.264 104.507 62.408ZM251.077 91.208H239.685V109H224.197V91.208H176.709V76.872L219.077 15.432H239.685V76.872H251.077V91.208ZM194.117 76.872H224.197V33.096L194.117 76.872Z" fill="#27272A"/>
      <rect width="256" height="120" fill="url(#paint0_linear_11902_75970)"/>
      <defs>
        <linearGradient id="paint0_linear_11902_75970" x1="128" y1="0" x2="128" y2="120" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0"/>
          <stop offset="0.844116" stopColor="white"/>
        </linearGradient>
      </defs>
    </svg>

  )
}

export default Icon404;
